import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Suspense as SuspenseComponent } from 'react';

function Suspense({ children }: { children: React.ReactNode }) {
  return (
    <SuspenseComponent
      fallback={
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: 4,
          }}
        >
          <CircularProgress />
          <div style={{ flex: 1 }} />
        </Box>
      }
    >
      {children}
    </SuspenseComponent>
  );
}

export default Suspense;
